import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class MyPicksTab extends Component {
  view() {
    if (!app.session.user) {
      return m("div", {
        className: "MyPicksPage-empty"
      }, m("p", null, app.translator.trans('huseyinfiliz-pickem.lib.messages.login_required')));
    }
    const {
      picks,
      loading,
      hasMore,
      onLoadMore
    } = this.attrs;
    const myPicks = Object.values(picks || {});
    const reverse = app.forum.attribute('pickem.reverseDisplay');
    if ((!myPicks || myPicks.length === 0) && !loading) {
      return m("div", {
        className: "MyPicksPage-empty"
      }, m("i", {
        className: "fas fa-clipboard-list",
        style: "font-size: 48px; opacity: 0.3; margin-bottom: 16px;"
      }), m("p", null, app.translator.trans('huseyinfiliz-pickem.lib.messages.no_data')));
    }
    const sortedPicks = myPicks.filter(pick => {
      const ev = pick.event();
      return ev !== false && ev !== null;
    }).sort((a, b) => {
      const eventA = a.event();
      const eventB = b.event();
      if (!eventA || !eventB) return 0;
      const dateA = eventA.matchDate() ? new Date(eventA.matchDate()).getTime() : 0;
      const dateB = eventB.matchDate() ? new Date(eventB.matchDate()).getTime() : 0;
      return dateB - dateA;
    });
    return m("div", null, m("div", {
      className: "PickemList PickemList--my-picks"
    }, m("div", {
      className: "PickemList-header"
    }, m("div", {
      className: "PickemList-cell type-match"
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.match')), m("div", {
      className: "PickemList-cell type-date"
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.date')), m("div", {
      className: "PickemList-cell type-pick"
    }, app.translator.trans('huseyinfiliz-pickem.forum.picks.your_pick')), m("div", {
      className: "PickemList-cell type-result"
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.result')), m("div", {
      className: "PickemList-cell type-status"
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.status'))), m("div", {
      className: "PickemList-body"
    }, sortedPicks.map(pick => {
      const event = pick.event();
      if (!event) return null;
      const homeTeam = event.homeTeam();
      const awayTeam = event.awayTeam();
      const pickId = pick.id();
      const isCorrect = pick.isCorrect();
      let itemClass = 'pending';
      if (isCorrect === true) itemClass = 'correct';
      if (isCorrect === false) itemClass = 'incorrect';
      let matchDate = '-';
      try {
        matchDate = dayjs(event.matchDate()).format('DD MMM YYYY');
      } catch {}
      const firstTeamName = reverse ? awayTeam ? awayTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.away') : homeTeam ? homeTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.home');
      const secondTeamName = reverse ? homeTeam ? homeTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.home') : awayTeam ? awayTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.away');
      return m("div", {
        key: String(pickId),
        className: `PickemList-item ${itemClass}`
      }, m("div", {
        className: "PickemList-cell type-match"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.common.match')), m("span", {
        className: "value"
      }, firstTeamName, " ", app.translator.trans('huseyinfiliz-pickem.lib.common.vs'), " ", secondTeamName)), m("div", {
        className: "PickemList-cell type-date"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.common.date')), m("span", {
        className: "value"
      }, matchDate)), m("div", {
        className: "PickemList-cell type-pick"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.forum.picks.your_pick')), m("span", {
        className: "value"
      }, this.formatResult(pick.selectedOutcome(), homeTeam, awayTeam))), m("div", {
        className: "PickemList-cell type-result"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.common.result')), m("span", {
        className: "value"
      }, event.result() ? this.formatResult(event.result(), homeTeam, awayTeam) : '-')), m("div", {
        className: "PickemList-cell type-status"
      }, m("span", {
        className: "mobile-label"
      }, app.translator.trans('huseyinfiliz-pickem.lib.common.status')), m("span", {
        className: "value"
      }, isCorrect === null ? m("span", {
        className: "PickStatus PickStatus--pending"
      }, m("i", {
        className: "fas fa-hourglass-half"
      }), " ", app.translator.trans('huseyinfiliz-pickem.lib.status.pending')) : isCorrect ? m("span", {
        className: "PickStatus PickStatus--correct"
      }, m("i", {
        className: "fas fa-check"
      }), " ", app.translator.trans('huseyinfiliz-pickem.lib.status.correct')) : m("span", {
        className: "PickStatus PickStatus--incorrect"
      }, m("i", {
        className: "fas fa-times"
      }), " ", app.translator.trans('huseyinfiliz-pickem.lib.status.incorrect')))));
    }))), hasMore && m("div", {
      className: "LoadMore"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: onLoadMore,
      loading: loading
    }, app.translator.trans('huseyinfiliz-pickem.lib.buttons.load_more'))));
  }
  formatResult(result, homeTeam, awayTeam) {
    if (result === 'home') return homeTeam ? homeTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.home');
    if (result === 'away') return awayTeam ? awayTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.away');
    if (result === 'draw') return app.translator.trans('huseyinfiliz-pickem.lib.common.draw');
    return result;
  }
}
flarum.reg.add('huseyinfiliz-pickem', 'forum/components/MyPicksTab', MyPicksTab);